import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/pages/login'], resolve),
    },
    {
      path: '/re_pwd',
      name: 're_pwd',
      component: resolve => require(['@/pages/personalCenter/rePwd'], resolve),
    },
    {
      path: '/re_phone',
      name: 're_phone',
      component: resolve => require(['@/pages/personalCenter/rePhone'], resolve),
    },
    // 首页
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/pages/main/layout'], resolve),
      children: [
        {
          path: '/data_board',
          name: 'data_board',
          component: resolve => require(['@/pages/main/dataBoard/index'], resolve),
        },
        {
          path: '/personal_center',
          name: 'personal_center',
          component: resolve => require(['@/pages/personalCenter'], resolve),
        },
        {
          path: '/company_approval',//审批分页列表
          name: 'company_approval',
          component: resolve => require(['@/pages/main/attestation/companyApproval'], resolve),
        },
        {
          path: '/org_approval',//组织申请审批
          name: 'org_approval',
          component: resolve => require(['@/pages/main/attestation/orgApproval'], resolve),
        },
        {
          path: '/banner',//日志管理
          name: 'banner',
          component: resolve => require(['@/pages/main/banner/index'], resolve),
        },
        {
          path: '/record',//日志管理
          name: 'record',
          component: resolve => require(['@/pages/main/record/index'], resolve),
        },
        {
          path: '/user',//系统用户管理
          name: 'user',
          component: resolve => require(['@/pages/main/system/systemUser/index'], resolve),
        },
        {
          path: '/company',//系统公司管理
          name: 'company',
          component: resolve => require(['@/pages/main/system/systemCompany/index'], resolve),
        },
        {
          path: '/file_Manage',//文档管理
          name: 'file_Manage',
          component: resolve => require(['@/pages/main/file/fileManage/index'], resolve),

        },
        {
          path: '/add_File',//创建文档
          name: 'add_File',
          component: resolve => require(['@/pages/main/file/fileManage/addFile'], resolve),
        },
        {
          path: '/edit_file',//创建文档
          name: 'edit_file',
          component: resolve => require(['@/pages/main/file/fileManage/editFile'], resolve),
        },
        {
          path: '/system_Content',//系统内容配置
          name: 'system_Content',
          component: resolve => require(['@/pages/main/file/systemContent'], resolve),
          children: [
            {
              path: '/page_File',//页面文档
              name: 'page_File',
              component: resolve => require(['@/pages/main/file/systemContent/filePage'], resolve),
            },
            {
              path: '/explain_File',//说明文档
              name: 'explain_File',
              component: resolve => require(['@/pages/main/file/systemContent/explainFile'], resolve),
            }
          ]
        },
      ]
    },
    {
      path: '/preview',//文档管理预览
      name: 'preview',
      component: resolve => require(['@/pages/main/file/fileManage/preview'], resolve),
    },
    {
      path: '/previews',//说明文档预览
      name: 'previews',
      component: resolve => require(['@/pages/main/file/systemContent/explainFile/previews'], resolve),
    },
    {
      path: '**',   // 错误路由[写在最后一个]
      redirect: '/login'   //重定向
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js